import { useEffect, useState } from 'react';
import { fetchOidcProviders, type OidcProvider } from '../grampsAuth';

export function useOidcProviders(): OidcProvider[] {
  const [providers, setProviders] = useState<OidcProvider[]>([]);

  useEffect(() => {
    let cancelled = false;
    void fetchOidcProviders().then((result) => {
      if (!cancelled) setProviders(result);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return providers;
}
